import React from 'react';
import { Typography } from '@mui/material';
import { WelcomeHeader } from './styledComponents';
import { PromptInput } from './PromptInput';

export const WelcomeScreen = ({
  inputValue,
  onInputChange,
  onSubmit,
  onKeyDown,
  isLoading,
  onStop,
  onPresetSelect,
}) => {
  return (
    <WelcomeHeader>
      <Typography variant="h3">What&apos;s on your mind today?</Typography>
      <Typography variant="body1" color="text.secondary" maxWidth={520}>
        Ask anything about your finances, reports, or next steps. I&apos;m here to
        help you navigate every decision with clarity.
      </Typography>
      <PromptInput
        value={inputValue}
        onChange={onInputChange}
        onSubmit={onSubmit}
        onKeyDown={onKeyDown}
        isLoading={isLoading}
        elevated={false}
        placeholder="Ask anything..."
        onStop={onStop}
        onPresetSelect={onPresetSelect}
      />
    </WelcomeHeader>
  );
};
